import { useState, useLayoutEffect, useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import SvgTabIndicator from "../../shared/svgTabIndicator/SvgTabIndicator";
import ConcertCardList from "../concertCardList/ConcertCardList";
import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SkellitonCard from "../../shared/skellitonCard/SkellitonCard";
import ConcertCard from "../../shared/concertCard/ConcertCard";
import ImageSliderHero from "../sliderImage";

const SlidingTabs = ({ setIsVisible }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [tabSet, setTabSet] = useState(false);
  const [indicatorStyles, setIndicatorStyles] = useState({
    width: 0,
    left: 0,
  });
  const tabsRef = useRef(null);

  useLayoutEffect(() => {
    AOS.init({ duration: 500, easing: "ease-in-out" }); // Initialize AOS
  }, []);

  useLayoutEffect(() => {
    const updateIndicatorStyles = () => {
      if (tabsRef.current) {
        const tabsContainer = tabsRef.current.getBoundingClientRect();
        const activeElement = tabsRef.current.children[activeTab];
        if (activeElement) {
          const activeElementRect = activeElement.getBoundingClientRect();
          setIndicatorStyles({
            width: activeElementRect.width,
            // Adjust `left` calculation to account for the scroll offset
            left:
              activeElementRect.left -
              tabsContainer.left +
              tabsRef.current.scrollLeft,
          });
        }
      }
    };

    updateIndicatorStyles();
    window.addEventListener("resize", updateIndicatorStyles);

    return () => {
      window.removeEventListener("resize", updateIndicatorStyles);
    };
  }, [activeTab]);
  const tabs = [
    { label: "Open to All", Component: ConcertCardList },
    { label: "Travel", icon: "✈️", Component: ConcertCardList },
    { label: "Relationships", icon: "❤️", Component: ConcertCardList },
    { label: "Taboo", icon: "🛑", Component: ConcertCardList },
    { label: "F&B", icon: "🍴", Component: ConcertCardList },
    { label: "Books/Movies", icon: "🎥", Component: ConcertCardList },
    { label: "In the shoes of", icon: "👟", Component: ConcertCardList },
    { label: "Others", icon: "🤔", Component: ConcertCardList },
  ];

  const ActiveComponent = tabs[activeTab].Component;

  const [cards, setCards] = useState([]);
  const [userLogin, setUserLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(8);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  const accessToken = localStorage.getItem("@user");

  const fetchCards = async () => {
    setLoading(true);
    try {
      const params = {
        access_token: accessToken,
        limit: limit,
        page: page,
      };

      if (activeTab > 0) {
        params.category = activeTab;
        setCards([]);
        setPage(1);
      }

      const response = await axios.get(
        `https://htprdapi.hightable.ai/tables/list-public`,
        { params }
      );
      setTimeout(() => {
        setLoading(false);
        setCards((prevCards) => [...prevCards, ...response.data.items]);
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCards();
  }, [activeTab, page]);

  const accesstoken = localStorage.getItem("@user");

  const handleNavigate = (name, id) => {
    const formattedName = name.replace(/\s+/g, "-"); // Replace spaces with dashes
    navigate(`/details?table=${encodeURIComponent(formattedName)}&id=${id}`);
  };

  const topRef = useRef(null);
  const handleLoadMore = (e) => {
    e.preventDefault();
    setPage((prevPage) => prevPage + 1); // Increase limit
    // window.scrollTo({
    //   top: 500, // Adjust this value to scroll slightly down (e.g., 100px from the top)
    //   behavior: "smooth", // Smooth scrolling effect
    // });
  };

  return (
    <>
      <section className="category-tab">
        <div
          data-current="Tab 1"
          data-easing="ease-in-out"
          data-duration-in="300"
          data-duration-out="300"
          className="tabs-2 w-tabs"
        >
         
          {tabSet ? (
            <div
              key={activeTab}
              data-aos="fade-up"
              data-aos-duration="1000"
              className="tabs-content-wrapper w-tab-content"
            >
              <div
                data-w-tab="Tab 1"
                className="tab-content-item w-tab-pane w--tab-active"
              >
                <div className="tab-content">
                  {accesstoken !== null ? (
                    <div className="w-layout-grid table-category-grid ">
                      {cards.map((card, index) => (
                        <div
                          key={index}
                          onClick={() => handleNavigate(card?.title, card.id)}
                        >
                          <ConcertCard slide={card} />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="w-layout-grid table-category-grid  ">
                      {cards.map((card, index) => (
                        <div
                          key={index}
                          onClick={() => handleNavigate(card?.title, card.id)}
                        >
                          <ConcertCard slide={card} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {loading ? (
                  <div className="tab-content">
                    <div className="w-layout-grid table-category-grid ">
                      {Array.from({ length: limit }, (_, index) => (
                        <SkellitonCard key={index} />
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div key={activeTab} className="tabs-content-wrapper w-tab-content">
              <div
                data-w-tab="Tab 1"
                className="tab-content-item w-tab-pane w--tab-active"
              >
                <div className="tab-content">
                  {accesstoken !== null ? (
                    <div className="w-layout-grid table-category-grid ">
                      {cards.map((card, index) => (
                        <div
                          key={index}
                          onClick={() => handleNavigate(card?.title, card.id)}
                        >
                          <ConcertCard slide={card} />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="w-layout-grid table-category-grid  ">
                      {cards.map((card, index) => (
                        <div
                          key={index}
                          onClick={() => handleNavigate(card?.title, card.id)}
                        >
                          <ConcertCard slide={card} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {loading ? (
                  <div className="tab-content">
                    <div className="w-layout-grid table-category-grid ">
                      {Array.from({ length: limit }, (_, index) => (
                        <SkellitonCard key={index} />
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
        {cards.length >= limit * page ? (
          <div
            className="flex justify-center items-center"
            onClick={handleLoadMore}
          >
            <button className="mt-8 mx-auto  bg-[#e2b760] hover:bg-[#bc8e32] text-white font-bold py-2 px-4 border border-[#bc8e32] rounded-2xl">
              Load more
            </button>
          </div>
        ) : (
          <div className="flex mt-4 justify-center text-center text-stone-400 items-center">
            No more tables here, but the seats are still comfy!
          </div>
        )}
      </section>
    </>
  );
};

export default SlidingTabs;
